<div class="modal fade" tabindex="-1" [id]="'videoModal'">
    <div class="modal-dialog modal-dialog-centered" >
        <div class="modal-content">
            <!--<div class="modal-header">
            </div>-->
            <div class="modal-body text-center">
                <video id="video" width="1160" height="650" controls>
                    <source type="video/mp4">
                  </video>
            </div>
            <div class="modal-footer">
                <button id="videoSkip" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{
                    'COMMON.SKIP' |
                    translate }}</button>
            </div>
        </div>
    </div>
</div>